<form #formRef="ngForm" [ngClass]="{'sidebar-active': !['flowchart', 'performance', 'react'].includes(activeTab)}">
	<bb-page-header [backOnMobile]="['/library/projects']" [icon]="'paper-plane'" [title]="entity ? entity.title : 'PROJECT' | translate">
		<div class="project-goal bb-header-extra" *ngIf="entity">
			{{ entity.goal }}
		</div>
		<ul class="tabs" *ngIf="entity">
			<li>
				<a [routerLink]="['/library/project', activeId, 'metadata']" routerLinkActive="" [class.active]="activeTab === 'metadata'"><!-- hack to fix routerLinkActive after create new -->
					<i class="fa fa-tags"></i> {{ 'METADATA' | translate }}
				</a>
			</li>
			<li>
				<a [routerLink]="['/library/project', activeId, 'flowchart']" routerLinkActive="active">
					<i class="fa fa-sitemap rotate-270"></i> {{ 'FLOWCHART' | translate }}
				</a>
			</li>
			<li>
				<a [routerLink]="['/library/project', activeId, 'thumbnail']" routerLinkActive="active">
					<i class="fa fa-image"></i> {{ 'THUMBNAIL' | translate }}
				</a>
			</li>
			<li>
				<a [routerLink]="['/library/project', activeId, 'embed']" routerLinkActive="active">
					<i class="fa fa-code"></i> {{ 'EMBED' | translate }}
				</a>
			</li>
			<li [hasPublicationField]="'projectKpiManagement'">
				<a [routerLink]="['/library/project', activeId, 'analysis']" routerLinkActive="active">
					<i class="fa fa-line-chart"></i> {{ 'KPIS' | translate }}
				</a>
			</li>
			<li *ngIf="entity && entity.id">
				<a [routerLink]="['/library/project', activeId, 'react']" routerLinkActive="active">
					<i class="fa fa-comments-o"></i> {{ 'REACT' | translate }}
				</a>
			</li>
		</ul>

		<bb-status *ngIf="entity" [(ngModel)]="entity.status" name="status"></bb-status>

	</bb-page-header>

	<div class="body-column tab-container">
		<library-project-details-metadata *ngIf="entity" [form]="form" [project]="entity" [hidden]="activeTab !== 'metadata'"></library-project-details-metadata>
		<library-project-details-flowchart *ngIf="entity && activeTab === 'flowchart'" [form]="form" [project]="entity" [hidden]="activeTab !== 'flowchart'" [statsMode]="activeTab === 'performance'" [checklistItems]="checklistItems"></library-project-details-flowchart>
		<library-project-details-thumbnail *ngIf="entity" [form]="form" [project]="entity" [hidden]="activeTab !== 'thumbnail'" (onThumbnailsChanged)="setChecklistItems('thumbnails', $event)"></library-project-details-thumbnail>
		<library-project-details-embed *ngIf="entity" [form]="form" [project]="entity" [mainMediaClip]="mainMediaClip" [hidden]="activeTab !== 'embed'" [isActive]="activeTab === 'embed'"></library-project-details-embed>
		<library-project-details-analysis *ngIf="entity && activeTab === 'analysis'" [project]="entity" [form]="form"></library-project-details-analysis>
		<library-project-details-react *ngIf="entity && entity.id && activeTab === 'react'" [project]="entity" [form]="form"></library-project-details-react>
	</div>
	<div class="body-column preview-container" [hidden]="['flowchart', 'react'].includes(activeTab)">

		<h3 class="mobile">{{'PREVIEW' | translate}}</h3>
		<ng-container *ngIf="MAYBE_LATER && entity && !isNew">
			<div [ngSwitch]="entity.mediatype" class="preview-wrapper">
				<div *ngSwitchCase="'video'">
					<bb-player
						(onPlayerCreated)="playerCreated($event)"
						[mediaclip]="entity" 
						[autoplay]="false"
						[playout]="previewPlayout"
						[playoutOverrides]="{width: '100%', responsiveSizing: 'true', allowImageSequence:'false', fullScreen:'Hide'}"></bb-player>
				</div>
				<div *ngSwitchCase="'audio'">
					<bb-player
						(onPlayerCreated)="playerCreated($event)"
						[mediaclip]="entity" 
						[autoplay]="false"
						[playout]="previewPlayout"
						[playoutOverrides]="{responsiveSizing:'false', height:'30',showBigPlayButton:'false',showBigReplayButton:'false',qualitySelector:'hide',fullScreen:'hide',volumeOrientation:'horizontal',timeDisplay:'Show progress time',controlBar:'Show',alphaControlBar:'100'}"></bb-player>
				</div>
				<img *ngSwitchCase="'image'" [src]="getThumbnail(entity.id,360,180)" class="thumb" />
			</div>
			<div class="actions">
				<span *ngIf="entity.mediatype==='video'" class="button" [ngClass]="{'active': preview}" (click)="preview = !preview"><i class="fa fa-arrows-h"></i>{{ 'PREVIEW' | translate }}</span>
			</div>
		</ng-container>
		<div class="entity-technical-details" *ngIf="entity">

			<bb-kpi-performance [project]="entity" [mode]="'sidebar'" *ngIf="entity?.kpiCalculations?.length" [isLoading]="loadingPerformanceData"></bb-kpi-performance>
			<div class="goto-btn" *ngIf="(entity?.status === 'published' || entity?.publisheddate) && !entity?.kpiCalculations?.length">
				<a class="button" [routerLink]="['/analytics/project/', entity?.id]">
					<i class="fa fa-line-chart"></i>
					<span class="short-label">{{ 'GO_TO_PROJECT_ANALYTICS' | translate }}</span>
				</a>
			</div>
			<bb-checklist [items]="checklistItems"></bb-checklist>
			<bb-sidebar-details 
				[project]="entity"
				[mainMediaClip]="mainMediaClip">
			</bb-sidebar-details>
			

			<pre *ngIf="entity && entity.stepData">
				{{ entity.stepData | json }}
			</pre>
		</div>
		<div [hasPermission]="'interactivity'">
			<h3>{{ 'INTERACTIVITY' | translate }}</h3>
			<div *ngIf="entity">
				<a class="button" (click)="editInteractivity()">{{ (hasTimeline() ? 'EDIT_INTERACTIVITY' : 'ADD_INTERACTIVITY') | translate }}</a>
			</div>
		</div>
	</div>
</form>

<bb-actions-bar (onSave)="save($event)" (onCancel)="cancel()" (onDelete)="delete($event)" [form]="form" [entity]="entity">
	<span *ngIf="entity && entity.mediatype==='video'" class="action-button" [ngClass]="{'active': preview}" (click)="preview = !preview">{{ 'PREVIEW' | translate }}</span>
</bb-actions-bar>
